import * as THREE from "three";
import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js";
import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader.js";

export const initScene = function() {
  let scene = new THREE.Scene();
  return scene;
};
// 初始化视角改这里
export const initCamera = function(clientWidth, clientHeight) {
  console.log(clientWidth);
  console.log(clientHeight);
  let camera = new THREE.OrthographicCamera(clientWidth*-1.8, clientWidth*1.8, clientHeight*1.8, clientHeight*-1.8, 1, 100000);

  camera.position.set( 5000, 5000, 9000 );  //轴测  //相机位置 改这里
  // camera.position.set( 0, 1000, 1000 );  //立面
  
  // camera.lookAt(new THREE.Vector3(5000,5000,0));
  // camera.lookAt(2000,2000,0);

  //相机看向哪个坐标
  // camera.lookAt({
  //     x : 5000,
  //     y : 5000,
  //     z : 0,
  // });

  // let camera = new THREE.OrthographicCamera(
  //   clientWidth / -2,
  //   clientWidth / 2,
  //   clientHeight / 2,
  //   clientHeight / -2,
  //   1,
  //   100000
  // );
  // camera.position.set(0, 500, 0);

  return camera;
};

export const initDefaultLights = function() {
  const light = new THREE.SpotLight(0xf1f1f1, 0.2);
  light.position.set(0, 500, 200);
  light.angle = Math.PI * 0.7;
  light.castShadow = true;
  light.shadow.camera.near = 200;
  light.shadow.camera.far = 2000;
  light.shadow.bias = -0.000222;
  light.shadow.mapSize.width = 1024;
  light.shadow.mapSize.height = 1024;
  return light;
};

export const initGroundPlane = function() {
  const planeGeometry = new THREE.PlaneGeometry(1000, 1000);
  planeGeometry.rotateX(-Math.PI / 2);
  const planeMaterial = new THREE.ShadowMaterial({ opacity: 0.2 });
  const plane = new THREE.Mesh(planeGeometry, planeMaterial);
  plane.position.y = -0.6;
  plane.receiveShadow = true;
  return plane;
};

export const initGridHelper = function() {
  const helper = new THREE.GridHelper(1000, 100);
  helper.position.y = -0.5;
  helper.material.opacity = 0.25;
  helper.material.transparent = true;
  return helper;
};

export const initRenderer = function(clientWidth, clientHeight) {
  let renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(clientWidth, clientHeight);
  renderer.setClearColor(1, 1, 1, 1);
  renderer.setClearAlpha(0.0);
  renderer.shadowMap.enabled = true;
  return renderer;
};

// export const initCSS2DRenderer = function(clientWidth, clientHeight){
//     let labelRenderer = new CSS2DRenderer()
//     labelRenderer.setSize(clientWidth,clientHeight)
//     labelRenderer.domElement.style.position = 'absolute'
//     labelRenderer.domElement.style.top = '0px'
//     labelRenderer.domElement.style.zIndex = 1
//     return labelRenderer
// }
//
export const initComposer = function(renderer, scene, camera) {
  const composer = new EffectComposer(renderer);
  const renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);
  return composer;
};

export const initOutlinePass = function(
  composer,
  renderer,
  scene,
  camera,
  window
) {
  const outlinePass = new OutlinePass(
    new THREE.Vector2(window.innerWidth, window.innerHeight),
    scene,
    camera
  );
  composer.addPass(outlinePass);

  const effectFXAA = new ShaderPass(FXAAShader);
  effectFXAA.uniforms["resolution"].value.set(
    1 / window.innerWidth,
    1 / window.innerHeight
  );
  composer.addPass(effectFXAA);

  outlinePass.edgeStrength = 1000;
  outlinePass.edgeGlow = 0;
  outlinePass.usePatternTexture = false;
  outlinePass.edgeThickness = 1;
  outlinePass.visibleEdgeColor.set("rgba(255,255,255)");
  // outlinePass.visibleEdgeColor.set("rgba(255,255,255，1)");
  outlinePass.hiddenEdgeColor.set("rgba(0,0,0,1)");

  return outlinePass;
};
